module.exports = __webpack_public_path__ + "static/M04_RiihimakiHohenberg2015-8559451326c9ec8e538a26c17445b527.jpg";